module.exports = __webpack_public_path__ + "media/images/pic/google-rating-400869a3eb641c53bfd758bf7b5c1319.svg";